import React from "react";
import { Box, Flex, Link, useColorModeValue } from "@chakra-ui/react";
import { FiAlertCircle } from "@react-icons/all-files/fi/FiAlertCircle";
import { Link as GatsbyLink } from "gatsby";

type VersionBannerProps = {
  courseSlug: string;
};

export const VersionBanner = ({ courseSlug }: VersionBannerProps) => {
  const bgColor = useColorModeValue("blue.50", "blue.700");
  return (
    <Flex px="8" py="2" bg={bgColor} align="center">
      <FiAlertCircle />
      <Box ml="4">
        You&apos;re currently on an older version of this course.{" "}
        <Link
          as={GatsbyLink}
          to={`/${courseSlug}#changelog`}
          textDecor="underline"
          _hover={{ textDecor: "none" }}
        >
          View course changelog
        </Link>
        .
      </Box>
    </Flex>
  );
};
